import type { MemberDataFirestoreRecord } from "@albertine/types";
import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { useMember } from "../../common/hooks/useMember";
import type { Conversation } from "../../common/types/Conversation";
import { FirebaseId } from "../../common/validate";
import { conversationDocument } from "../../FirebaseBackend";
import { listenToDocumentToState } from "../../FirebaseListenerToState";

type Props = {
    children: (
        member: MemberDataFirestoreRecord,
        conversation: Conversation,
    ) => React.JSX.Element;
};

function FetchMemberAndConversation(props: { member: string | undefined } & Props) {
    const { member, children } = props;

    const [conversation, setConversation] = useState<Conversation>();

    const { data: memberData } = useMember(member);

    useEffect(() => {
        if (
            !memberData?.conversation ||
            !FirebaseId.safeParse(memberData?.conversation).success
        ) {
            return undefined;
        }
        return listenToDocumentToState<Conversation>(
            conversationDocument(memberData.conversation),
            setConversation,
        );
    }, [memberData?.conversation]);

    if (!memberData || !conversation) {
        return null;
    }
    return children(memberData, conversation);
}

export default FetchMemberAndConversation;

export function FetchMemberAndConversationFromRoute(
    props: { path: string | string[] } & Props,
) {
    const { path, children } = props;
    const memberId = useRouteMatch<{
        memberId: string;
    }>(path)?.params.memberId;

    return (
        <FetchMemberAndConversation member={memberId}>
            {children}
        </FetchMemberAndConversation>
    );
}
